var img = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 20L7.5 20L7.5 17.5L4.375 17.5L8.75 13.125L6.875 11.25L2.5 15.625L2.5 12.5L-6.55671e-07 12.5L0 20Z' fill='white'/%3e%3cpath d='M20 0L12.5 0V2.5L15.625 2.5L11.25 6.875L13.125 8.75L17.5 4.375V7.5H20V0Z' fill='white'/%3e%3c/svg%3e";

export { img as default };
